// extracted by mini-css-extract-plugin
module.exports = {"body":"ShareModal_body__QOegI","header":"ShareModal_header__7Z18d","title":"ShareModal_title__0HBxo"};